<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <v-flex xs12 sm8>
        <v-card class="elevation-12 default-border">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{
              this.$route.params.id
                ? "Edição de Empresa"
                : "Cadastro de Empresa"
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form
              v-model="formularioCadastroValido"
              ref="formularioCadastroRef"
            >
              <v-container grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 md5>
                    <v-text-field
                      v-model="cadastroModel.nome"
                      color="secondary"
                      :rules="regras.branco"
                      prepend-icon="business_center"
                      label="Nome da empresa"
                      type="text"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-model="cadastroModel.cnpj"
                      color="secondary"
                      :rules="regras.branco"
                      prepend-icon="chrome_reader_mode"
                      label="CNPJ"
                      :mask="maskCnpj"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-btn
                      id="finalizar"
                      color="primary"
                      class="default-border"
                      depressed
                      small
                      @click="buscarCNPJ"
                      :disabled="!cadastroModel.cnpj"
                      >Buscar</v-btn
                    >
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      ref="txtdividaEstadualFormatado"
                      v-model="dividaEstadualFormatado"
                      color="secondary"
                      prepend-icon="attach_money"
                      label="Divida Estadual"
                      v-money="maskMoney"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      ref="txtdividaFederalFormatado"
                      v-model="dividaFederalFormatado"
                      color="secondary"
                      prepend-icon="attach_money"
                      label="Divida Federal"
                      v-money="maskMoney"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      v-model="cadastroModel.tipoOrigem"
                      color="secondary"
                      :items="listTipoOrigem"
                      item-text="nome"
                      prepend-icon="fa fa-magnet"
                      label="Origem"
                      return-object
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      v-model="cadastroModel.tipoSegmento"
                      color="secondary"
                      :items="listTipoSegmento"
                      item-text="nome"
                      prepend-icon="fa-briefcase"
                      label="Segmento"
                      return-object
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      v-model="cadastroModel.tipoStatusNegociacao"
                      color="secondary"
                      :items="listStatusNegociacao"
                      item-text="nome"
                      :rules="regras.branco"
                      prepend-icon="fa-handshake"
                      label="Status Negociação"
                      return-object
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      v-model="cadastroModel.usuario"
                      color="secondary"
                      :items="listaUsuarios"
                      :rules="regras.branco"
                      item-text="nome"
                      prepend-icon="business_center"
                      label="Usuário Responsável"
                      return-object
                      riquired
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="cadastroModel.whatapp"
                      color="secondary"
                      prepend-icon="fab fa-whatsapp"
                      :mask="maskTelefone"
                      label="WhatsApp"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="cadastroModel.celular"
                      color="secondary"
                      prepend-icon="perm_phone_msg"
                      :mask="maskTelefone"
                      label="Celular"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-text-field
                      v-model="cadastroModel.telefone"
                      color="secondary"
                      prepend-icon="perm_phone_msg"
                      label="Telefone"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 md7>
                    <v-text-field
                      v-model="cadastroModel.endereco"
                      color="secondary"
                      prepend-icon="fa fa-map-signs"
                      label="Endereço"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-text-field
                      v-model="cadastroModel.complemento"
                      color="secondary"
                      prepend-icon="fa fa-map-signs"
                      label="Complemento"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-model="cadastroModel.cep"
                      color="secondary"
                      prepend-icon="fa fa-location-arrow"
                      label="Cep"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-btn
                      id="finalizar"
                      color="primary"
                      class="default-border"
                      depressed
                      small
                      @click="buscarCEP"
                      :disabled="!cadastroModel.cep"
                      >Buscar</v-btn
                    >
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="cadastroModel.bairro"
                      color="secondary"
                      prepend-icon="fa fa-map-signs"
                      label="Bairro"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-select
                      v-model="cadastroModel.geoCidade.geoEstado.sigla"
                      color="secondary"
                      :items="estados"
                      :options="estados"
                      prepend-icon="place"
                      label="Estado"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-autocomplete
                      v-model="cadastroModel.geoCidade.nome"
                      color="secondary"
                      :items="cidades"
                      item-text="nome"
                      label="Cidade"
                      flat
                      hide-no-data
                      hide-details
                      browser-autocomplete="new-password"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="cadastroModel.email"
                      color="secondary"
                      prepend-icon="mail"
                      label="Email"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="cadastroModel.site"
                      color="secondary"
                      prepend-icon="fa fa-sitemap"
                      label="Site"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-select
                      v-model="cadastroModel.usuarioLogin"
                      color="secondary"
                      :items="listaUsuariosClientes"
                      item-text="nome"
                      prepend-icon="business_center"
                      label="Usuário Cliente"
                      return-object
                      :disabled="usuarioLogado.idconta != contaMetta"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              id="voltar"
              color="primary"
              class="grey--text text--darken-1"
              :to="{ name: 'Empresas' }"
              flat
              >Voltar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              id="finalizar"
              color="primary"
              class="default-border"
              depressed
              @click="finalizar"
              :disabled="disableBtnFinalizar || !formValid"
              >Finalizar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="5000"
      :color="`${snackbarModel.sucesso ? 'success' : 'error'}`"
      bottom
      multi-line
      v-model="snackbarModel.mostrar"
    >
      {{ snackbarModel.text }}
      <v-btn
        flat
        dark
        @click.native="
          `${
            snackbarModel.sucesso
              ? go('Pessoas')
              : (snackbarModel.mostrar = false)
          }`
        "
        >Fechar</v-btn
      >
    </v-snackbar>
  </v-container>
</template>


<script>
import cipher from "@/helpers/cipher.js";
import jwt from "@/helpers/jwt";
import brasil from "@/assets/estados/brasil.json";
import customFormat from "@/helpers/custom-format.js";
import usuarioHelper from "@/helpers/usuario.js";
import { VMoney } from "v-money";

export default {
  name: "CadastroEmpresa",
  directives: {
    money: VMoney,
  },
  data: () => ({
    formularioCadastroValido: false,
    disableBtnFinalizar: false,
    dividaEstadualFormatado: 0.0,
    dividaFederalFormatado: 0.0,
    listTipoOrigem: [],
    listTipoSegmento: [],
    listStatusNegociacao: [],
    listaUsuarios: [],
    listaUsuariosClientes: [],
    brasil,
    cidades: [],
    estados: [
      { value: null, text: "Selecione" },
      { value: "AC", text: "AC" },
      { value: "AL", text: "AL" },
      { value: "AP", text: "AP" },
      { value: "AM", text: "AM" },
      { value: "BA", text: "BA" },
      { value: "CE", text: "CE" },
      { value: "DF", text: "DF" },
      { value: "ES", text: "ES" },
      { value: "GO", text: "GO" },
      { value: "MA", text: "MA" },
      { value: "MT", text: "MT" },
      { value: "MS", text: "MS" },
      { value: "MG", text: "MG" },
      { value: "PA", text: "PA" },
      { value: "PB", text: "PB" },
      { value: "PR", text: "PR" },
      { value: "PE", text: "PE" },
      { value: "PI", text: "PI" },
      { value: "RJ", text: "RJ" },
      { value: "RN", text: "RN" },
      { value: "RS", text: "RS" },
      { value: "RO", text: "RO" },
      { value: "RR", text: "RR" },
      { value: "SC", text: "SC" },
      { value: "SP", text: "SP" },
      { value: "SE", text: "SE" },
      { value: "TO", text: "TO" },
    ],
    cadastroModel: {
      idEmpresa: null,
      nome: null,
      cnpj: null,
      dividaEstadual: null,
      dividaFederal: null,
      whatapp: null,
      celular: null,
      telefone: null,
      tipoOrigem: null,
      tipoSegmento: null,
      tipoStatusNegociacao: { nome: "Prospecção", idTipoStatusNegociacao: 3 },
      endereco: null,
      complemento: null,
      cep: null,
      geoCidade: { nome: null, idGeoCidade: null, geoEstado: { sigla: null } },
      bairro: null,
      email: null,
      site: null,
      usuario: null,
      contaCriador: {
        idConta: jwt.decryptToken().idconta,
      },
      usuarioLogin: null,
    },
    snackbarModel: {
      mostrar: false,
      text: "",
      sucesso: false,
    },
    maskMoney: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      precision: 2,
      masked: false,
    },
    maskTelefone: "(##)#####-####",
    maskCnpj: "##.###.###/####-##",
    regras: {
      branco: [(v) => !!v || "Você não pode deixar este campo em branco"],
      email: [
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Você precisa informar um e-mail válido",
      ],
    },
  }),
  computed: {
    formValid: function () {
      return this.formularioCadastroValido;
    },
    customFormatComputed: function () {
      return customFormat;
    },
    usuarioLogado: function () {
      return usuarioHelper.USUARIO_LOGADO();
    },
    contaMetta: function () {
      return `${process.env.ID_CONTA_METTA}`;
    },
  },
  watch: {
    dividaEstadualFormatado: function (val) {
      this.cadastroModel.dividaEstadual = customFormat.removeMoneyFormat(val);
    },
    dividaFederalFormatado: function (val) {
      this.cadastroModel.dividaFederal = customFormat.removeMoneyFormat(val);
    },
    "cadastroModel.geoCidade.geoEstado.sigla": function () {
      this.cidades = brasil.find(
        (e) => e.sigla === this.cadastroModel.geoCidade.geoEstado.sigla
      ).geoCidadeSimplesModelList;
    },
  },
  mounted: function () {
    this.buscarUsuario();
    this.buscarUsuarioClientes();
    this.buscarTipoOrigem();
    this.buscarTipoSegmento();
    this.buscarStatusNegociacao();
    this.buscarEmpresas();
  },
  methods: {
    buscarUsuario: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(
            `${process.env.URL_API}/usuario/v1/busca/nome/conta/ativas/` +
              jwt.decryptToken().idconta,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaUsuarios = response.data;
            self.listaUsuarios.sort(self.customFormatComputed.compareNome);
          });
      } else {
        self.go("Login");
      }
    },
    buscarUsuarioClientes: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(
            `${process.env.URL_API}/usuario/v1/busca/metta/nome/conta/ativas/` +
              jwt.decryptToken().idconta,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaUsuariosClientes = response.data;
            const vazio = { idUsuario: 0, nome: "Vazio" };
            self.listaUsuariosClientes.push(vazio);
            self.listaUsuariosClientes.sort(
              self.customFormatComputed.compareNome
            );
          });
      } else {
        self.go("Login");
      }
    },
    buscarEmpresas: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        if (
          this.$route.params.id &&
          Number.isInteger(parseInt(cipher.decrypt(this.$route.params.id)))
        ) {
          self.$http
            .get(
              `${process.env.URL_API}/empresa/v1/busca/conta/` +
                jwt.decryptToken().idconta +
                `/` +
                cipher.decrypt(this.$route.params.id),
              {
                headers: {
                  Authorization:
                    "Bearer " + JSON.parse(localStorage.getItem("token")),
                },
              }
            )
            .then(function (response) {
              const resposta = response.data[0];
              self.cadastroModel.idEmpresa = resposta.idEmpresa;
              self.cadastroModel.nome = resposta.nome;
              self.cadastroModel.cnpj = resposta.cnpj;
              self.cadastroModel.whatapp = resposta.whatapp;
              self.cadastroModel.celular = resposta.celular;
              self.cadastroModel.telefone = resposta.telefone;
              self.cadastroModel.tipoOrigem = resposta.tipoOrigem;
              self.cadastroModel.tipoSegmento = resposta.tipoSegmento;
              self.cadastroModel.tipoStatusNegociacao =
                resposta.tipoStatusNegociacao;
              self.cadastroModel.endereco = resposta.endereco;
              self.cadastroModel.complemento = resposta.complemento;
              self.cadastroModel.cep = resposta.cep;

              self.cadastroModel.bairro = resposta.bairro;
              self.cadastroModel.email = resposta.email;
              self.cadastroModel.site = resposta.site;
              self.cadastroModel.usuario = resposta.usuario;

              if (resposta.usuarioLogin) {
                self.listaUsuariosClientes.push(resposta.usuarioLogin);
                self.cadastroModel.usuarioLogin = resposta.usuarioLogin;
              }

              self.$refs.txtdividaEstadualFormatado.$el.getElementsByTagName(
                "input"
              )[0].value = parseFloat(resposta.dividaEstadual)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\,)/g, "$&.");

              self.$refs.txtdividaFederalFormatado.$el.getElementsByTagName(
                "input"
              )[0].value = parseFloat(resposta.dividaFederal)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\,)/g, "$&.");

              if (resposta.geoCidade != null) {
                self.cadastroModel.geoCidade = resposta.geoCidade;
              }
            });
        }
      }
    },
    buscarTipoOrigem: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(`${process.env.URL_API}/tipoorigem/v1/busca/`, {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          })
          .then(function (response) {
            self.listTipoOrigem = response.data;
            self.listTipoOrigem.sort(self.customFormatComputed.compareNome);
          });
      } else {
        self.go("Login");
      }
    },
    buscarCidadeEstado: function (cidade, uf) {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(
            `${process.env.URL_API}/cidadeestado/v1/busca/` + cidade + `/` + uf,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.cadastroModel.geoCidade = response.data;
          });
      } else {
        self.go("Login");
      }
    },
    buscarTipoSegmento: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(`${process.env.URL_API}/tiposegmento/v1/busca/`, {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          })
          .then(function (response) {
            self.listTipoSegmento = response.data;
            self.listTipoSegmento.sort(self.customFormatComputed.compareNome);
          });
      } else {
        self.go("Login");
      }
    },
    buscarStatusNegociacao: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(`${process.env.URL_API}/tipostatusnegociacao/v1/busca/`, {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          })
          .then(function (response) {
            self.listStatusNegociacao = response.data;
            self.listStatusNegociacao.sort(
              self.customFormatComputed.compareNome
            );
          });
      } else {
        self.go("Login");
      }
    },
    buscarCNPJ: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(
            `${process.env.URL_API}/empresa/v1/busca/cnpj/` +
              self.cadastroModel.cnpj,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            console.log(response.data);

            if (response.data.status == "OK") {
              self.cadastroModel.nome = response.data.nome;

              self.cadastroModel.bairro = response.data.bairro;
              self.cadastroModel.endereco =
                response.data.logradouro + ", " + response.data.numero;
              self.cadastroModel.complemento = response.data.complemento;
              self.cadastroModel.cep = response.data.cep
                .replace("-", "")
                .replace(".", "");
              self.buscarCidadeEstado(
                response.data.municipio,
                response.data.uf
              );
              self.cadastroModel.telefone = response.data.telefone;
              self.cadastroModel.email = response.data.email;
            } else {
              alert("CPNJ Não encontrado");
            }
          });
      } else {
        self.go("Login");
      }
    },
    finalizar: function () {
      const self = this;
      self.$store.commit("startLoading");
      if (self.$refs.formularioCadastroRef.validate()) {
        const item = jwt.decryptToken();
        if (item != null) {
          if (
            self.cadastroModel.usuarioLogin &&
            self.cadastroModel.usuarioLogin.idUsuario == 0
          ) {
            self.cadastroModel.usuarioLogin = null;
          }
          if (!self.$route.params.id) {
            self.$http
              .post(
                `${process.env.URL_API}/empresa/v1/cadastro`,
                self.cadastroModel,
                {
                  headers: {
                    Authorization:
                      "Bearer " + JSON.parse(localStorage.getItem("token")),
                  },
                }
              )
              .then(function (response) {
                const data = response.data;
                if (data.sucesso) {
                  self.disableBtnFinalizar = data.sucesso;
                  self.go("Empresas", {
                    snackbarText: data.mensagem,
                    snackbarMostrar: true,
                    snackbarSucesso: data.sucesso,
                  });
                } else {
                  self.snackbarModel.text = data.mensagem;
                  self.snackbarModel.mostrar = true;
                  self.snackbarModel.sucesso = data.sucesso;
                  self.disableBtnFinalizar = data.sucesso;
                }
              })
              .catch(function (error) {
                self.snackbarModel.text = error.response.data.message;
                self.snackbarModel.sucesso = false;
                self.snackbarModel.mostrar = true;
                self.disableBtnFinalizar = false;
              });
          } else {
            self.cadastroModel.idEmpresa = cipher.decrypt(
              self.$route.params.id
            );
            self.$http
              .post(
                `${process.env.URL_API}/empresa/v1/edicao`,
                self.cadastroModel,
                {
                  headers: {
                    Authorization:
                      "Bearer " + JSON.parse(localStorage.getItem("token")),
                  },
                }
              )
              .then(function (response) {
                const data = response.data;
                if (data.sucesso) {
                  self.disableBtnFinalizar = data.sucesso;
                  self.go("Empresas", {
                    snackbarText: data.mensagem,
                    snackbarMostrar: true,
                    snackbarSucesso: data.sucesso,
                  });
                } else {
                  self.snackbarModel.text = data.mensagem;
                  self.snackbarModel.mostrar = true;
                  self.snackbarModel.sucesso = data.sucesso;
                  self.disableBtnFinalizar = data.sucesso;
                }
              })
              .catch(function (error) {
                self.snackbarModel.text = error.response.data.message;
                self.snackbarModel.sucesso = false;
                self.snackbarModel.mostrar = true;
                self.disableBtnFinalizar = false;
              });
          }
        } else {
          self.go("Login");
        }
      }
      self.$store.commit("endLoading");
    },
    buscarCEP: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(
            `https://viacep.com.br/ws/` + self.cadastroModel.cep + `/json/`,
            {}
          )
          .then(function (response) {
            console.log(response.data);

            self.cadastroModel.endereco = response.data.logradouro;
            self.cadastroModel.bairro = response.data.bairro;

            self.buscarCidadeEstado(response.data.localidade, response.data.uf);
          });
      } else {
        self.go("Login");
      }
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (this.$router.currentRoute.name != routeName) {
        if (!routeParams) {
          self.$router.push({ name: routeName });
        } else {
          self.$router.push({ name: routeName, params: routeParams });
        }
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/clientes/CadastroEmpresa.vue